import { createContext, Dispatch, SetStateAction } from 'react'

export const defaultContext = {
  charts: {} as { [x: string]: { data: IChartData[]; includesAll: boolean } },
  setCharts: {} as Dispatch<
    SetStateAction<{
      [x: string]: {
        data: IChartData[]
        includesAll: boolean
      }
    }>
  >,
  devicePhotoRefreshCounter: 0,
  setDevicePhotoRefreshCounter: (() => {}) as Dispatch<SetStateAction<number>>,
}

const DeviceContext = createContext(defaultContext)

export default DeviceContext
